
export class ProviderAuditUsageStatisticsModel {
  accessMode: string;
  count: number;
  actionDate: Date;
}
